import { NgModule } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { LazyTranslateLoader } from './lazy-translate-loader';

export function LoaderFactory(): LazyTranslateLoader {
  return new LazyTranslateLoader(['./translations/i18n/']);
}
@NgModule({
  imports: [
    TranslateModule.forRoot({
      defaultLanguage: environment.language.default,
      loader: {
        provide: TranslateLoader,
        useFactory: LoaderFactory,
      },
    }),
  ],
})
export class TranslateModuleFactory {}
